import { resourceTypes } from "../../../Findings/FindingsUtils";

const { GROUP } = resourceTypes as { GROUP: string };

export interface ScopeGraphChild {
  label?: string;
  has_scope_descendants?: boolean;
  value?: {
    id?: string;
    type?: string;
  };
}

export const isEmptyScopeGroup = (child?: ScopeGraphChild): boolean =>
  child?.value?.type === GROUP && !child?.has_scope_descendants;

export const getRenderableScopeChildren = <T extends ScopeGraphChild>(
  children: T[] | undefined
): T[] => (children ?? []).filter((child) => !isEmptyScopeGroup(child));
